import { Map } from 'immutable'

import { TASK_STATES } from '../../scenes/Gnosus/components/EntityStack/components/StackContent/components/ExportsContent/constants'

export const getRibbonBlocks = (state, moduleName, arrayName) =>
    state.getIn(['ui', 'modules', moduleName, 'ribbon', arrayName, 'data'])
export const getAppState = (state) => state.get('appState')

export const getSuccessfulJobs = (state) =>
    state
        .getIn(['ui', 'entityStack', 'exports', 'jobs'], Map())
        .filter((value) => value?.state === TASK_STATES.SUCCEEDED)
